import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const SIDE_IMG = "https://images.unsplash.com/photo-1772004839793-e0b97d449a19?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Login() {
  const { loginEmail } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const onEmailSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await loginEmail(email, pw);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}.`);
      navigate("/portal");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-ivory">
      {/* Left: image */}
      <div className="relative hidden md:block">
        <img src={SIDE_IMG} alt="Quiet morning" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-jade/35" />
        <div className="relative z-10 h-full flex flex-col justify-between p-14">
          <Link to="/" className="font-serif text-3xl text-ivory">Abbot <span className="italic text-copper">Asia</span></Link>
          <div>
            <p className="eyebrow text-copper">Client Portal</p>
            <p className="font-serif text-ivory text-4xl mt-3 leading-tight max-w-md italic">
              "The night before our journey, every detail was already in place."
            </p>
          </div>
        </div>
      </div>

      {/* Right: form */}
      <div className="flex items-center justify-center px-6 py-20 md:py-0">
        <div className="w-full max-w-md">
          <p className="eyebrow">Welcome back</p>
          <h1 className="mt-4 font-serif text-4xl md:text-5xl text-jade font-light">Sign in to your journey.</h1>
          <p className="mt-4 text-ink/70 text-[15px] font-light">Access your itinerary, documents, and concierge.</p>

          <form onSubmit={onEmailSubmit} className="mt-10 space-y-6">
            <div>
              <label className="eyebrow">Email</label>
              <input data-testid="login-email" type="email" required className="input-line mt-3" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label className="eyebrow">Password</label>
              <input data-testid="login-password" type="password" required className="input-line mt-3" value={pw} onChange={(e) => setPw(e.target.value)} />
            </div>
            <button data-testid="login-submit" disabled={busy} type="submit" className="btn-primary w-full disabled:opacity-50">
              {busy ? "Signing in…" : "Sign In"}
            </button>
          </form>

          <p className="mt-8 text-[13px] text-ink/65">
            New traveller? <Link to="/register" data-testid="link-register" className="text-jade underline-offset-4 hover:underline">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
